module.exports = __webpack_public_path__ + "img/IT0004836404211.5994b8f9.png";